
import {Vue, Component} from 'vue-property-decorator';
import {integrityApi} from "@/api/integrity";
const {regionData, CodeToText} = require("@/js/region/region");
import SelectMechanism from "@/components/SelectMechanism.vue";
import ckeditor4 from "@/components/CkeditorComponent.vue";
import baseUrl, {imageUrl} from "@/constants";
import CreditListCommon from "@/views/integrity/CreditListCommon.vue";
import Credit from "@/views/integrity/Credit.vue"
import {mechanismApi} from "@/api/organization";
@Component({
    components: {
        CreditListCommon,Credit,
        ckeditor4,SelectMechanism
    }
})
export default class Order extends Vue {
    private organizations = [];// 企业列表
    private showQuery = false;
    private showDetailDialog = false;
    private regionData = regionData;
    private loading = false;
    private CodeToText = CodeToText;
    private currentOrgId = "";
    private queryParams = {
        name: '',
        area: '',
        status: 1,
        current: 1,
        size: 10,
        total: 0
    }


    imageUrl() {
        return imageUrl
    }

    baseUrl() {
        return baseUrl;
    }

    mounted() {
        // 加载企业列表
        this.loadData();
    }

    loadData(){
      this.clearSelectedTable();
        this.loading = true;
        mechanismApi.list(this.queryParams).then((r: any) => {
            this.loading = false;
            if (r.data.result === 0) {
                const rData = r.data.data.records;
                this.queryParams.total = r.data.data.total;
                this.organizations = rData;
            }
        }).catch(() => {
            this.loading = false;
        })
    }
  reset(){
    this.queryParams.name='';
    this.queryParams.area =''
    this.loadData();
  }

    showDetail(){
        if(this.isCheckedOne()){
            // 显示企业信息弹框
            this.currentOrgId = (this.selectedItems[0] as any).id;
            this.showDetailDialog = true;
        }
    }

    isCheckedOne(){
        if(this.isChecked()){
            if(this.selectedItems.length !== 1){
                this.$message.error("请先选择一条记录");
                return false;
            }
        }

        return true;
    }

    isChecked(){
        if(!this.selectedItems || this.selectedItems.length === 0){
            this.$message.error("请先选择一条记录");
            return false;
        }

        return true;
    }

    private selectedItems = [];
    onSelectItem(selection: any, row: any) {
        this.selectedItems = selection;
    }
    pageSizeChange(val: number) {
        this.queryParams.size = val;
        this.loadData();
    }
    pageCurrentChange(val: number) {
        this.queryParams.current = val;
        this.loadData();
    }
    indexMethod(index: any) {
        return (this.queryParams.current-1)*this.queryParams.size+index+1;
    }
    onClickTableView(row: any){
      this.currentOrgId = row.id;
      this.showDetailDialog = true;
    }
  clearSelectedTable(){
    this.selectedItems = [];
    let $table = this.$refs.table as HTMLFormElement;
    if($table){
      $table.clearSelection();
    }
  }
}
